import React from "react";
import { html as htmlLang } from "@codemirror/lang-html";
import CodeMirror from "@uiw/react-codemirror";
import { okaidia } from "@uiw/codemirror-theme-okaidia";
import { Box } from "@mui/material";
//import "./index.css";

//docs for CodeMirror: https://uiwjs.github.io/react-codemirror


export default function QuestionCodeEditor(props) {
  
  const { name } = props
  const { html } = props
  const { setHtml } = props
  const { sx } = props
  const { disabled } = props

  const handleChange = (value, viewUpdate) => {
    setHtml(value)
  };

  return (
    <Box sx={sx} className="editor-container">
      HTML
      <CodeMirror
        readOnly={disabled}
        onChange={handleChange}
        value={html}
        name={name}
        className="codemirror-wrapper"
        theme={okaidia}
        height="100%"
        extensions={[
          htmlLang({ matchClosingTags: true, autoCloseTags: false }),
        ]}
      />
    </Box>
  );
}
